module.exports = __webpack_public_path__ + "static/media/new_landing_page_banner.51cc816a.svg";